module.exports = __webpack_public_path__ + "img/udm.7cbd5ebd.png";